module.exports = __webpack_public_path__ + "static/media/icone-pdf-branco.b5860d2f.svg";